"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// calculates the total price for the cruise
function currencyConversionPrice(_state, getters) {
    return function (currentPrice) {
        var price = currentPrice;
        // currency conversion? re-calculate price
        if (getters['currency/convert']) {
            price = currentPrice * getters['currency/conversion'];
        }
        // return sum
        return price;
    };
}
exports.default = currencyConversionPrice;
//# sourceMappingURL=currencyConversionPrice.js.map